<template>
    <div class="fixed top-0 w-full bg-white p-3 flex justify-center items-center">
        <img class="  object-contain" src="Coke-company-logo-black.svg" alt="Coca Cola Logo black">
    </div>
</template>